import { CSSProperties, useEffect, useState } from 'react';

import { OverlayData } from 'types';
import { ImageLoader } from 'utils';
import { mediaSizeSetup } from './helpers';

type Props = {
  imageUrl: string;
  onLoad: () => void;
  onAction: (data: OverlayData) => void;
};

const ImageContent = ({ imageUrl, onLoad, onAction }: Props) => {
  const [style, setStyle] = useState<CSSProperties>();

  useEffect(() => {
    if (imageUrl) {
      const loader = new ImageLoader(imageUrl, (w, h) => {
        const style = mediaSizeSetup(w, h);
        style.cursor = 'pointer';

        setStyle(style);
        onLoad();
      });

      return () => loader.cancel();
    }

    onLoad();
  }, [imageUrl, onLoad]);

  return style ? (
    <img
      width={style.width}
      height={style.height}
      src={imageUrl}
      alt=""
      style={style}
      onClick={
        imageUrl
          ? () => onAction({ type: 'image', payload: { url: imageUrl } })
          : undefined
      }
    />
  ) : null;
};

export default ImageContent;
